import {
    useContractWrite,
    usePrepareContractWrite,
    useWaitForTransaction,
    useContractEvent,
} from "wagmi";

import { useEffect, useState, useRef } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import {
    getSetApprovalDef,
    getSetBurnableApprovalDef,
    getGumballDef,
    getBurnableGumballDef,
    getMaticGumballDef,
} from "./ContractWrites";
import { BurnableSelector } from "./BurnableSelector";
import Modal from "react-modal";
import toast from "react-hot-toast";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import { NftCard } from "./NftCard";
import PropTypes from "prop-types";
import s from "./GumballContainer.module.css";
import { gumballAbi } from "../assets/abis/gumballAbi";
import { CircleLoader } from "react-spinners";
import { useWindowDimensions } from "../hooks/UseWindowDimensions";

const configWithGas = (config) => {
    if (config && config.request) {
        if (config.request.gasLimit) {
            const configWithGas = {
                ...config,
                request: {
                    ...config.request,
                    gasLimit: config.request.gasLimit.mul(200).div(100),
                },
            };

            return configWithGas;
        }
    }

    return null;
};

const GumballContainer = ({
    wallet,
    addresses,
    loadedPrizes,
    processingComplete,
    prizesCount,
    animaCost,
    animaAllowance,
    animaDisplayCost,
    animaBalance,
    animaDisplayBalance,
    animaDisplayAllowance,
    burnableEnabled,
    burnableContract,
    burnableName,
    burnableSymbol,
    burnableSelectedId,
    burnableApproved,
    setBurnableSelectedId,
    maticCost,
    maticDisplayCost,
    maticEnabled,
    maticBalance,
    maticDisplayBalance,
    availableTokens,
    lastType,
    setLastType,
    burnableNfts,
    burnableBalances,
    infosComplete,
    paused,
    allInfos,
    refetchReadGumball,
    refetchBurnableBalances,
    setAllInfos,
    refetchAnima,
}) => {
    //const alchemy = new Alchemy(config);
    const toastId = useRef(0);
    //const initialized = useRef(false);

    const { height: inHeight, width: inWidth } = useWindowDimensions();

    const [gumballRequested, setGumballRequested] = useState(false);
    const [gumballStarted, setGumballStarted] = useState(false);
    const [burnableSelectExpanded, setBurnableSelectExpanded] = useState(false);

    const [burnableRequested, setBurnableRequested] = useState(false);

    const [configPrepareGumballWithGas, setconfigPrepareGumballWithGas] =
        useState({});
    const [configApprovalWithGas, setConfigApprovalWithGas] = useState({});

    const [configPrepareMaticWithGas, setConfigPrepareMaticWithGas] = useState(
        {}
    );

    const [
        configPrepareBurnableApprovalWithGas,
        setConfigPrepareBurnableApprovalWithGas,
    ] = useState({});

    const [configPrepareBurnableWithGas, setConfigPrepareBurnableWithGas] =
        useState({});

    const [newEvent, setNewEvent] = useState([]);

    const [prizeExpanded, setPrizeExpanded] = useState(false);
    const [prizeInfo, setPrizeInfo] = useState({});

    const closePrize = () => {
        setPrizeExpanded(false);
    };

    //----------------------------Set Amima approval
    // configue the call to setApprovalForAll
    const { config: configSetApproval, status: statusSetapproval } =
        usePrepareContractWrite(
            getSetApprovalDef(addresses.anima, addresses.gumball, animaCost)
        );

    useEffect(() => {
        /* console.log(
            `statusSetApproval ${statusSetapproval} configSetApproval: ${JSON.stringify(
                configSetApproval
            )}`
        ); */

        if (statusSetapproval == "success") {
            if (configSetApproval.request) {
                if (configSetApproval.request.gasLimit) {
                    const configWithGas = {
                        ...configSetApproval,
                        request: {
                            ...configSetApproval.request,
                            gasLimit: configSetApproval.request.gasLimit
                                .mul(300)
                                .div(100),
                        },
                    };

                    setConfigApprovalWithGas(configWithGas);
                }
            }
        }
    }, [statusSetapproval, animaCost]);

    //set up the hook to call the write and get the data back
    const { data: setApprovalData, writeAsync: approvalWrite } =
        useContractWrite(configApprovalWithGas);

    /* useEffect(() => {
        console.log(
            "approval with gas changed: " +
                JSON.stringify(configApprovalWithGas)
        );
    }, [configApprovalWithGas]); */

    //set up the hook to get the result of set approval
    const {
        isLoading: setApprovalLoading,
        isError: setApprovalError,
        isSuccess: setApprovalSuccess,
    } = useWaitForTransaction({
        hash: setApprovalData?.hash,
    });

    useEffect(() => {
        if (setApprovalLoading) {
            const id = toastId.current;
            toast.loading(`Approving $ANIMA Spend!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });
            toastId.current = id;
        } else {
            toast.remove();
        }
    }, [setApprovalLoading]);

    useEffect(() => {
        toast.remove();
        if (setApprovalSuccess) {
            refetchAnima();
        }
        if (setApprovalError) {
            //console.log("setApprovalError:" + JSON.stringify(setApprovalError));
            setGumballRequested(false);
            setGumballStarted(false);
        }
    }, [setApprovalSuccess, setApprovalError]);

    useEffect(() => {
        if (setApprovalError) {
            const id = toastId.current;
            toast.error(`Set approval Failed, Please try again!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });
        }
    }, [setApprovalError]);

    //----------------------------Do ANIMA Gumball
    const {
        config: configPrepareGumball,
        status: statusPrepareGumball,
        refetch: refetchPrepareGumball,
    } = usePrepareContractWrite(
        getGumballDef(
            addresses.gumball,
            animaAllowance.gte(animaCost) && !paused
        )
    );

    useEffect(() => {
        if (statusPrepareGumball == "success") {
            const config = configWithGas(configPrepareGumball);

            if (config) setconfigPrepareGumballWithGas(config);
        }

        if (statusPrepareGumball == "error") {
            //prepare sometimes fails because the allow is not refetched yet
            refetchPrepareGumball();
        }
    }, [statusPrepareGumball]);

    //set up the hook to call the write and get the data back
    const { data: setGumballData, writeAsync: gumballWrite } = useContractWrite(
        configPrepareGumballWithGas
    );

    //set up the hook to get the result of gumball
    const {
        data: gumaballReceipt,
        isLoading: gumballLoading,
        isError: gumballError,
        isSuccess: gumballSuccess,
    } = useWaitForTransaction({
        hash: setGumballData?.hash,
    });

    const startGumball = async () => {
        try {
            if (!gumballStarted) {
                const id = toast.loading(`Rolling Gacha`, {
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
                toastId.current = id;
                setGumballStarted(true);
                setLastType("gumball");
                await gumballWrite();
            }
        } catch (error) {
            toast.remove();
            setGumballRequested(false);
            setGumballStarted(false);
            console.error(error);
        }
    };

    const doGumball = async () => {
        //console.log("gumball start");
        setGumballRequested(true);
        if (animaAllowance.lt(animaCost)) {
            //need to set enough allowance
            //console.log("request approval");
            try {
                const id = toast.loading(`Requesting $ANIMA Approval`, {
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
                toastId.current = id;
                await approvalWrite();
            } catch (error) {
                toast.remove();
                setGumballRequested(false);
                console.error(error);
            }
        } else {
            //already allowed just gumball
            if (!gumballStarted) {
                console.log(`Gumball from do gumball!`);
                await startGumball();
            }
        }
    };

    useEffect(() => {
        if (
            animaAllowance.gte(animaCost) &&
            statusPrepareGumball == "success" &&
            !gumballStarted &&
            gumballRequested
        ) {
            /* console.log(
                `GUMBALL! gumballRequested: ${gumballRequested} allowance: ${animaAllowance} prepareGumball: ${statusPrepareGumball} gumballStarted: ${gumballStarted}`
            ); */
            (async () => {
                await startGumball();
            })();
        } else {
            /* console.log(
                `not gumballing gumballRequested: ${gumballRequested} allowance: ${animaAllowance} prepareGumball: ${statusPrepareGumball} gumballStarted: ${gumballStarted}`
            ); */
        }
    }, [
        gumballRequested,
        statusPrepareGumball,
        gumballStarted,
        animaAllowance,
        animaCost,
    ]);

    useEffect(() => {
        if (gumballLoading) {
            const id = toastId.current;
            toast.loading(`Rolling ANIMA Gacha!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });
            toastId.current = id;
        } else {
            toast.remove();
        }
    }, [gumballLoading]);

    useEffect(() => {
        if (!gumballLoading && (gumballSuccess || gumballError)) {
            setGumballStarted(false);
            setGumballRequested(false);
        }
    }, [gumballSuccess, gumballError, gumballLoading]);

    useEffect(() => {
        if (gumballSuccess) {
            const id = toastId.current;
            toast.success(`Roll Gacha Success!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });

            refetchAnima();
            refetchReadGumball();
        } else {
            if (gumballError) {
                const id = toastId.current;
                toast.error(`Roll Gacha Failed, Please try again!`, {
                    id: id,
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
            }
        }
    }, [gumballSuccess, gumballError]);

    useContractEvent({
        address: addresses.gumball,
        abi: gumballAbi,
        eventName: "GachaSent",
        listener: (index, contractAddress, tokenID, to) => {
            //add this to the end of the array
            setNewEvent((previous) => [
                ...previous,
                { index, contractAddress, tokenID, to },
            ]);
        },
    });

    useEffect(() => {
        //console.log(`new event: ${JSON.stringify(newEvent)}`);
        if (newEvent && newEvent.length > 0) {
            //get the first element
            const copy = [...newEvent];
            const event = copy.shift();

            //console.log(`handle first event: ${JSON.stringify(event)}`);

            const index = event.index.toNumber();
            const contract = event.contractAddress.toLowerCase();
            const tokenId = event.tokenID.toString();

            const key = `${contract}:${tokenId}`;

            let value = {};

            if (key in allInfos) {
                //this token already exists just add to the count
                value = allInfos[key];
                let _count = value.count;
                value = {
                    ...value,
                    count: _count - 1,
                };

                if (value.count > 0) {
                    setAllInfos((prevAllInfos) => ({
                        ...prevAllInfos,
                        [key]: value,
                    }));
                    //console.log("Updated count");
                } else {
                    setAllInfos((prevAllInfos) => {
                        const copy = { ...prevAllInfos };
                        delete copy[key];

                        return copy;
                    });
                    //console.log("Removed item");
                }
            }

            if (event.to == wallet) {
                console.log(`match! ${event.to} ${wallet}`);
                setPrizeInfo([key, value]);
                setPrizeExpanded(true);
            } else {
                console.log(`no match! ${event.to} ${wallet}`);
            }

            //remove the first event
            setNewEvent(copy);

            refetchReadGumball();
        }
    }, [newEvent]);

    //--------------------set burnable approval
    const {
        config: configSetBurnableApproval,
        error: errorSetBurnableApproval,
        status: statusSetBurnableApproval,
    } = usePrepareContractWrite(
        getSetBurnableApprovalDef(burnableContract, addresses.gumball)
    );

    useEffect(() => {
        if (statusSetBurnableApproval == "success") {
            const config = configWithGas(configSetBurnableApproval);

            if (config) setConfigPrepareBurnableApprovalWithGas(config);
        }
    }, [statusSetBurnableApproval]);

    //set up the hook to call the write and get the data back
    const { data: setBurnableApprovalData, writeAsync: burnableApprovalWrite } =
        useContractWrite(configPrepareBurnableApprovalWithGas);

    //set up the hook to get the result of set approval
    const {
        isLoading: setBurnableApprovalLoading,
        isError: setBurnableApprovalError,
        isSuccess: setBurnableApprovalSuccess,
    } = useWaitForTransaction({
        hash: setBurnableApprovalData?.hash,
    });

    useEffect(() => {
        if (setBurnableApprovalLoading) {
            const id = toastId.current;
            toast.loading(`Approving ${burnableSymbol} Spend!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });
            toastId.current = id;
        } else {
            toast.remove();
        }
    }, [setBurnableApprovalLoading]);

    useEffect(() => {
        toast.remove();
        if (setBurnableApprovalSuccess) {
            refetchBurnableBalances();
        }
        if (setBurnableApprovalError) {
            //console.log("setApprovalError:" + JSON.stringify(setApprovalError));
            setBurnableRequested(false);
            setGumballStarted(false);
        }
    }, [setBurnableApprovalSuccess, setBurnableApprovalError]);

    useEffect(() => {
        if (setBurnableApprovalError) {
            const id = toastId.current;
            toast.error(
                `Set ${burnableSymbol} approval Failed, Please try again!`,
                {
                    id: id,
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                }
            );
        }
    }, [setBurnableApprovalError]);

    //--------------------DO BURNABLE GUMBALL
    const {
        config: configPrepareBurnable,
        error: errorPrepareBurnable,
        status: statusPrepareBurnable,
        refetch: refetchPrepareBurnable,
    } = usePrepareContractWrite(
        getBurnableGumballDef(
            addresses.gumball,
            burnableSelectedId,
            burnableApproved &&
                burnableSelectedId >= 0 &&
                Object.hasOwn(burnableBalances, burnableSelectedId) &&
                burnableBalances[burnableSelectedId] > 0
        )
    );

    /* useEffect(() => {
        if (errorPrepareBurnable) {
            console.log(
                `errorPrepareBurnable: ${JSON.stringify(errorPrepareBurnable)}`
            );
        }
    }, [errorPrepareBurnable]); */

    useEffect(() => {
        if (statusPrepareBurnable == "success") {
            const config = configWithGas(configPrepareBurnable);

            if (config) {
                /* console.log(
                    `configPrepareBurnableWithGas updated!  ${JSON.stringify(
                        config
                    )}`
                ); */
                setConfigPrepareBurnableWithGas(config);
            }
        }

        if (statusPrepareBurnable == "error") {
            console.error(
                `prepare burnable error! config = ${JSON.stringify(
                    configPrepareBurnable
                )}`
            );

            //prepare sometimes fails because the allow is not refetched yet
            refetchPrepareBurnable();
        }
    }, [statusPrepareBurnable, burnableSelectedId]);

    //set up the hook to call the write and get the data back
    const { data: setBurnableData, writeAsync: burnableWrite } =
        useContractWrite(configPrepareBurnableWithGas);

    const {
        data: burnableReceipt,
        isLoading: burnableLoading,
        isError: burnableError,
        isSuccess: burnableSuccess,
    } = useWaitForTransaction({
        hash: setBurnableData?.hash,
    });

    const startBurnable = async () => {
        try {
            if (!gumballStarted && configPrepareBurnableWithGas) {
                toast.remove();
                const id = toast.loading(`Rolling Gacha`, {
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
                toastId.current = id;
                setGumballStarted(true);
                setLastType("burnable");
                await burnableWrite();
            }
        } catch (error) {
            /* console.log(
                `configPrepareBurnableWithGas = ${JSON.stringify(
                    configPrepareBurnableWithGas
                )}`
            ); */

            toast.remove();
            setBurnableRequested(false);
            setGumballStarted(false);
            console.error(error);
        }
    };

    const doBurnable = async () => {
        //console.log("burnable start");
        setBurnableRequested(true);
        if (!burnableApproved) {
            //need to set enough allowance
            //console.log("request burnable approval");
            try {
                const id = toast.loading(
                    `Requesting ${burnableSymbol} Approval`,
                    {
                        position: "bottom-center",
                        style: {
                            border: "1px solid black",
                            fontSize: "x-large",
                        },
                    }
                );
                toastId.current = id;
                await burnableApprovalWrite();
            } catch (error) {
                toast.remove();
                setGumballRequested(false);
                console.error(error);
            }
        } else {
            //already allowed just gumball
            if (!gumballStarted) {
                //console.log(`Gumball from doBurnable!`);

                const id = toast.loading(`Loading...`, {
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
                toastId.current = id;
            }
        }
    };

    useEffect(() => {
        if (
            burnableApproved &&
            burnableRequested &&
            statusPrepareBurnable == "success" &&
            configPrepareBurnableWithGas &&
            !gumballStarted
        ) {
            /* console.log(
                `BURNABLE! burnableRequested: ${burnableRequested} allowance: ${burnableApproved} statusPrepareBurnable: ${statusPrepareBurnable} gumballStarted: ${gumballStarted}`
            ); */
            (async () => {
                await startBurnable();
            })();
        } else {
            /* console.log(
                `not burnableing burnableRequested: ${burnableRequested} allowance: ${burnableApproved} statusPrepareBurnable: ${statusPrepareBurnable} gumballStarted: ${gumballStarted}`
            ); */
        }
    }, [
        gumballRequested,
        statusPrepareGumball,
        gumballStarted,
        animaAllowance,
        animaCost,
    ]);

    useEffect(() => {
        if (burnableLoading) {
            const id = toastId.current;
            toast.loading(`Rolling ${burnableSymbol} Gacha!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });
            toastId.current = id;
        } else {
            toast.remove();
        }
    }, [burnableLoading]);

    useEffect(() => {
        if (!burnableLoading && (burnableSuccess || burnableError)) {
            setGumballStarted(false);
            setBurnableRequested(false);
        }
    }, [burnableSuccess, burnableError, burnableLoading]);

    useEffect(() => {
        if (burnableSuccess) {
            const id = toastId.current;
            toast.success(`Roll Gacha Success!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });
            setBurnableSelectedId(-1);
            refetchReadGumball();
            refetchBurnableBalances();
        } else {
            if (burnableError) {
                const id = toastId.current;
                toast.error(`Roll Gacha Failed, Please try again!`, {
                    id: id,
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
            }
        }
    }, [burnableSuccess, burnableError]);

    const chooseBurnable = () => {
        setBurnableSelectedId(-1);
        setBurnableSelectExpanded(true);
    };

    const selectedBurnable = (id) => {
        //console.log(`selectedBurnable ${id}`);
        setBurnableSelectedId(id);
        setBurnableSelectExpanded(false);

        if (id >= 0) {
            doBurnable();
        }
    };

    const closeBurnableModal = () => {
        setBurnableSelectedId(-1);
        setBurnableSelectExpanded(false);
    };

    //--------------------DO MATIC GUMBALL
    const {
        config: configPrepareMatic,
        error: errorPrepareMatic,
        status: statusPrepareMatic,
        refetch: refetchPrepareMatic,
    } = usePrepareContractWrite(
        getMaticGumballDef(
            addresses.gumball,
            maticCost,
            maticEnabled && maticBalance.gte(maticCost)
        )
    );

    useEffect(() => {
        if (statusPrepareMatic == "success") {
            const config = configWithGas(configPrepareMatic);

            if (config) setConfigPrepareMaticWithGas(config);
        }

        if (statusPrepareMatic == "error") {
            //prepare sometimes fails because the allow is not refetched yet
            refetchPrepareMatic();
        }
    }, [statusPrepareMatic]);

    //set up the hook to call the write and get the data back
    const { data: setMaticData, writeAsync: maticWrite } = useContractWrite(
        configPrepareMaticWithGas
    );

    //set up the hook to get the result of gumball
    const {
        data: maticReceipt,
        isLoading: maticLoading,
        isError: maticError,
        isSuccess: maticSuccess,
    } = useWaitForTransaction({
        hash: setMaticData?.hash,
    });

    const startMatic = async () => {
        try {
            if (!gumballStarted) {
                const id = toast.loading(`Rolling Matic Gacha`, {
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
                toastId.current = id;
                setGumballStarted(true);
                setLastType("matic");
                await maticWrite();
            }
        } catch (error) {
            toast.remove();
            setGumballRequested(false);
            setGumballStarted(false);
            console.error(error);
        }
    };

    const doMatic = async () => {
        //console.log("matic gumball start");

        if (!gumballStarted) {
            //console.log(`Gumball from do matic!`);
            await startMatic();
        }
    };

    useEffect(() => {
        if (!maticLoading && (maticSuccess || maticError)) {
            setGumballStarted(false);
            setGumballRequested(false);
        }
    }, [maticSuccess, maticError, maticLoading]);

    useEffect(() => {
        if (maticSuccess) {
            const id = toastId.current;
            toast.success(`Roll Gacha Success!`, {
                id: id,
                position: "bottom-center",
                style: {
                    border: "1px solid black",
                    fontSize: "x-large",
                },
            });

            refetchAnima();
            refetchReadGumball();
        } else {
            if (maticError) {
                const id = toastId.current;
                toast.error(`Roll Gacha Failed, Please try again!`, {
                    id: id,
                    position: "bottom-center",
                    style: {
                        border: "1px solid black",
                        fontSize: "x-large",
                    },
                });
            }
        }
    }, [maticSuccess, maticError]);

    //----------------------REACT DISPLAY

    return (
        <div className={s.gumball}>
            <div>Available Prizes: {availableTokens}</div>

            <div>
                {loadedPrizes && infosComplete && processingComplete ? (
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={inWidth > 600 ? 2 : 1}
                        loop={true}
                        autoplay={{
                            delay: 500,
                            disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                        className={s.mySwiper}
                    >
                        {Object.entries(allInfos).map(([key, value]) => (
                            <SwiperSlide key={key} className={s.swiperSlide}>
                                <NftCard
                                    index={key}
                                    value={value}
                                    showCount={true}
                                    showReceipt={false}
                                />{" "}
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <>
                        <div className={s.spinners}>
                            <div>
                                {prizesCount <= 0
                                    ? "loading prize data please wait..."
                                    : prizesCount < availableTokens
                                    ? `loaded ${prizesCount} prizes...`
                                    : `processing data...`}
                            </div>
                            <CircleLoader size="150px" color="#646cff" />
                        </div>
                    </>
                )}
            </div>
            <hr />
            <div className={s.animaGumball}>
                {availableTokens <= 0 ? (
                    <>
                        <div>Gacha is Empty!</div>
                        <div>Please check again later!</div>
                    </>
                ) : (
                    <>
                        {!paused ? (
                            <div className={s.purchaseContainer}>
                                <div className={s.purchaseSection}>
                                    <div className={s.sectionHead}>
                                        ANIMA Gacha
                                    </div>
                                    <div className={s.cost}>
                                        Gacha Costs{" "}
                                        {animaDisplayCost.toString()} ANIMA
                                    </div>

                                    <div className={s.balance}>
                                        Your ANIMA:{" "}
                                        {animaDisplayBalance.toString()}
                                    </div>

                                    <div>&nbsp;</div>

                                    <div className={s.animaAllowance}>
                                        Allowed:{" "}
                                        {animaDisplayAllowance.toString()} ANIMA
                                    </div>

                                    {animaBalance.lt(animaCost) ? (
                                        <div className={s.balanceError}>
                                            Insufficient ANIMA
                                        </div>
                                    ) : (
                                        <div>&nbsp;</div>
                                    )}

                                    <button
                                        className={s.gumballButton}
                                        disabled={
                                            gumballRequested ||
                                            animaBalance.lt(animaCost) ||
                                            burnableRequested
                                        }
                                        onClick={() => doGumball?.()}
                                    >
                                        {gumballRequested ||
                                        animaBalance.lt(animaCost) ||
                                        burnableRequested
                                            ? "Busy"
                                            : "Roll Gacha"}
                                    </button>
                                </div>
                                {burnableEnabled && (
                                    <div className={s.purchaseSection}>
                                        <div className={s.sectionHead}>
                                            Burnable Gacha
                                        </div>
                                        <div>
                                            Burn {burnableSymbol} for Gacha
                                        </div>
                                        <div>{burnableName}</div>
                                        <div>&nbsp;</div>
                                        <div className={s.animaAllowance}>
                                            {burnableApproved
                                                ? "Approved"
                                                : "Needs Approval"}
                                        </div>
                                        <div>&nbsp;</div>
                                        <button
                                            className={s.gumballButton}
                                            disabled={
                                                gumballRequested ||
                                                burnableRequested
                                            }
                                            onClick={() => chooseBurnable?.()}
                                        >
                                            {gumballRequested ||
                                            burnableRequested
                                                ? "Busy"
                                                : "Roll Gacha"}
                                        </button>
                                    </div>
                                )}
                                {maticEnabled && (
                                    <div className={s.purchaseSection}>
                                        <div className={s.sectionHead}>
                                            MATIC Gacha
                                        </div>
                                        <div className={s.cost}>
                                            Gacha Costs{" "}
                                            {maticDisplayCost.toString()} MATIC
                                        </div>

                                        <div className={s.balance}>
                                            Your MATIC:{" "}
                                            {maticDisplayBalance.toString()}
                                        </div>

                                        <div>&nbsp;</div>
                                        <div>&nbsp;</div>

                                        {maticBalance.lt(maticCost) &&
                                        !paused ? (
                                            <div className={s.balanceError}>
                                                Insufficient MATIC
                                            </div>
                                        ) : (
                                            <div>&nbsp;</div>
                                        )}

                                        <button
                                            className={s.gumballButton}
                                            disabled={
                                                gumballRequested ||
                                                burnableRequested
                                            }
                                            onClick={() => doMatic?.()}
                                        >
                                            {gumballRequested ||
                                            burnableRequested
                                                ? "Busy"
                                                : "Roll Gacha"}
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <>
                                <div>Gacha is paused!</div>
                                <div>Please check back later!</div>
                            </>
                        )}
                    </>
                )}
            </div>

            <Modal
                isOpen={prizeExpanded}
                appElement={document.getElementById("root") || undefined}
                className={s.Modal}
                overlayClassName={s.Overlay}
            >
                <div className={s.showPrize}>
                    Your Prize:
                    <NftCard
                        addresses={addresses}
                        index={prizeInfo[0]}
                        value={prizeInfo[1]}
                        showCount={false}
                        showReceipt={true}
                        receipt={
                            lastType == "matic"
                                ? maticReceipt
                                : lastType == "gumball"
                                ? gumaballReceipt
                                : lastType == "burnable"
                                ? burnableReceipt
                                : null
                        }
                    />
                    <button
                        className={s.modalClose}
                        onClick={() => closePrize()}
                    >
                        close
                    </button>
                </div>
            </Modal>

            <Modal
                isOpen={burnableSelectExpanded}
                appElement={document.getElementById("root") || undefined}
                className={s.Modal}
                overlayClassName={s.Overlay}
            >
                <BurnableSelector
                    collectionData={burnableNfts}
                    burnables={burnableBalances}
                    selectedBurnable={selectedBurnable}
                />

                <button
                    className={s.modalClose}
                    onClick={() => closeBurnableModal()}
                >
                    close
                </button>
            </Modal>
        </div>
    );
};

GumballContainer.propTypes = {
    wallet: PropTypes.string,
    addresses: PropTypes.object,
    loadedPrizes: PropTypes.bool,
    processingComplete: PropTypes.bool,
    prizesCount: PropTypes.number,
    animaCost: PropTypes.object,
    animaDisplayCost: PropTypes.number,
    animaAllowance: PropTypes.object,
    burnableContract: PropTypes.string,
    burnableSelectedId: PropTypes.number,
    burnableApproved: PropTypes.bool,
    maticCost: PropTypes.object,
    maticDisplayCost: PropTypes.number,
    maticEnabled: PropTypes.bool,
    availableTokens: PropTypes.number,
    lastType: PropTypes.string,
    setLastType: PropTypes.func,
    burnableNfts: PropTypes.array,
    burnableBalances: PropTypes.object,
    infosComplete: PropTypes.bool,
    paused: PropTypes.bool,
    animaBalance: PropTypes.object,
    animaDisplayBalance: PropTypes.number,
    animaDisplayAllowance: PropTypes.number,
    burnableEnabled: PropTypes.bool,
    burnableSymbol: PropTypes.string,
    burnableName: PropTypes.string,
    allInfos: PropTypes.object,
    setBurnableSelectedId: PropTypes.func,
    refetchReadGumball: PropTypes.func,
    refetchBurnableBalances: PropTypes.func,
    setAllInfos: PropTypes.func,
    refetchAnima: PropTypes.func,
    maticBalance: PropTypes.object,
    maticDisplayBalance: PropTypes.number,
};

export { GumballContainer };
